
import { defineComponent } from 'vue';
import SBtn from 'SharedComponents/ui/Button/SBtn.vue';

export default defineComponent({
  name: 'STableSettings',
  components: { SBtn },
  props: {
    /**
     * Необходимо ли привлечь пользователя к кнопке вызова настроек таблицы
     */
    highlight: {
      type: Boolean,
    },
  },
});
